import { IconWrapper, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--color-text-weak)';

export const QuizLeaderboardIcon = ({
  textColor = DEFAULT_COLOR,
  size,
}: IconProps) => (
  <IconWrapper size={size}>
    <path d="M10 21.5V17H5.5V21.5H10Z" fill={textColor} />
    <path d="M10 14.5V10H5.5V14.5H10Z" fill={textColor} />
    <path
      d="M12 10H24.75C25.9926 10 27 11.0074 27 12.25C27 13.4926 25.9926 14.5 24.75 14.5H12V10Z"
      fill={textColor}
    />
    <path
      d="M12 17H18.75C19.9926 17 21 18.0074 21 19.25C21 20.4926 19.9926 21.5 18.75 21.5H12V17Z"
      fill={textColor}
    />
  </IconWrapper>
);
